import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                91<span className="text-primary-400">视频</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              专注提供零缓冲观影服务，蓝光画质与超清剧场任你选。海量高清电影和热门电视剧实时更新。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading tracking-wide">影片分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading tracking-wide">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  播放帮助
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  意见反馈
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  免责声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading tracking-wide">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-background-400">contact@jiangdaotech.cn</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-background-400">400-888-9999</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-background-400">24小时在线客服</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 91免费在线视频 版权所有 | 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}